import React from "react";
import { Switch, Route, useHistory } from "react-router-dom";
import { connect } from "react-redux";
import Login from "./components/login";
import Home from "./components/home";
import "./App.css";
import axios from "axios";
import actions from "./store/actions";
import reactGA from "react-ga";
import { getProfileKey } from "./utils/keycloakProfile";
import { isAccessTokenValid } from "./services/keycloakTokenService";

const INTUGINE_TOKEN_TTL_MS = 24 * 60 * 60 * 1000;

function isIntugineTokenFresh(fetchedAt) {
  if (!fetchedAt) {
    return false;
  }
  return Date.now() - fetchedAt < INTUGINE_TOKEN_TTL_MS;
}

function App(props) {
  const history = useHistory();
  const fetchedForProfileKeyRef = React.useRef(null);

  // const fullAcess = [
  //   // "akshayrana@intugine.com",
  //   // "mandar@intugine.com",
  //   // "zevik@intugine.com", // Left the company
  //   // "yashu@intugine.com",
  //   "niranjan@intugine.com",
  //   // "vikas@intugine.com",  // Left the company
  //   "keshav@intugine.com",
  //   "ayush@intugine.com",
  //   // "rohit@intugine.com",
  //   "kunal@intugine.com",
  //   "mayankmittal@intugine.com",
  //   // 'mahim@intugine.com',
  //   // "gokul@intugine.com",
  //   // "harshitha@intugine.com",
  //   // "fahad@intugine.com",
  //   "lovepreet@intugine.com",
  //   // 'sandeep@intugine.com',
  //   // "srinath@intugine.com",
  //   "akhil@intugine.com",
  //   // "ayub@intugine.com",  // Left the company
  //   // "kunal@intugine.com",
  //   // "pratyushaudichya@intugine.com",
  //   "anubhavchaturvedi@intugine.com",
  //   "vaibhav@intugine.com",
  //   // "kunalpant@intugine.com",
  //   // "lakhandhanani@intugine.com",
  //   // "adityasingh@intugine.com",
  //   "abhisheksharma@intugine.com",
  //   "shivareji@intugine.com",
  //   "aniketshaw@intugine.com",
  //   "vikalpmohnani@intugine.com",
  //   // "nikhilsati@intugine.com",
  //   "amrita@intugine.com",
  //   "prasurjya@intugine.com",
  //   "waquar@intugine.com",
  //   // "gajanand@intugine.com",
  //   "pulkitsrivastava@intugine.com",
  //   // "shawn@intugine.com",
  //   "anubhavnirwal@intugine.com",
  //   "nitieshkumar@intugine.com",
  //   "kaminipathak@intugine.com",
  //   "ravirajyadav@intugine.com",
  //   "hatimsunelwala@intugine.com",
  //   "kunalkumar@intugine.com",
  //   // "nishithirani@intugine.com",
  //   "hassan@intugine.com",
  //   "rsaundatikar@intugine.com",
  //   "adithyaumashankar@intugine.com",
  //   "krishaanusyal@intugine.com",
  //   "ashishajgaonkar@intugine.com",
  //   "pratik@intugine.com",
  //   "sunder@intugine.com",
  //   "nikitapardeshi@intugine.com",
  //   "radhika@intugine.com",
  //   "sudhanshukumar@intugine.com",
  //   "diksha@intugine.com",
  //   "parkavi@intugine.com",
  //   "adityakumar@intugine.com",
  //   "ajaykumar@intugine.com",
  //   "karanveer@intugine.com",
  //   "saniya@intugine.com",
  //   "harish@intugine.com",
  //   "akashacharya@intugine.com",
  //   "vagdevi@intugine.com",
  //   "heenaluthra@intugine.com",
  //   "armaan@intugine.com",
  //   "shreyash@intugine.com",
  //   "simerpreet@intugine.com",
  //   "nityansh@intugine.com",
  //   "rajkrishna@intugine.com",
  //   "prakashmeda@intugine.com",
  //   "harivishnu@intugine.com",
  //   "khushbookhatayat@intugine.com",
  //   "ajaylahoti@intugine.com",
  //   "krishnashivaram@intugine.com",
  //   "fouzia@intugine.com",
  //   "anusha@intugine.com",
  //   "prajwal@intugine.com",
  //   "jugal@intugine.com",
  //   "soumajit@intugine.com",
  //   "gayatri@intugine.com",
  //   "ajayk@intugine.com",
  //   "pradish@intugine.com",
  //   "veeresh@intugine.com",
  //   "soumik@intugine.com",
  //   "vamshi@intugine.com"
  // ];

  const TP_OPS_TOKEN =
    "7f3d8b9a2c1e5f4b6d8a0c2e4f6b8d0a2c4e6f8b0d2a4c6e8f0b2d4a6c8e0f2a";

  const apps = {
    "Tickets V2": `https://development.d17znz2l88iewh.amplifyapp.com/?token=${props.token}&email=${props.email}&access_token=${props.keycloakAccessToken}`,
    // 'Tickets V2': 'https://development.d2jq2wvhkq6025.amplifyapp.com/?token=' + props.token,
    // Tickets: `https://master.d5ikz781z2rxb.amplifyapp.com/auth/token?token=${props.token}&email=${props.email}`,
    // Tickets: 'https://master.d5ikz781z2rxb.amplifyapp.com/auth/token?token=' + props.token,
    Inspect: `https://master.d2irnw472yr6lw.amplifyapp.com/?email=${props.email}`,
    // Inspect: 'https://d31hfepe47varr.cloudfront.net/',
    "Ops View": `https://main.d35huhcizfjt5w.amplifyapp.com/?email=${props.email}`,
    // 'Ops View': 'https://master.d8ubw6164160y.amplifyapp.com/',
    Device: `https://devicebank.intusystems.info/?user=${props.username}&email=${props.email}`,
    // Device: 'https://devicebank.intusystems.info/?user=' + props.username,
    "User Mgmgt": `https://sct-user-mgmt.intusystems.info/?user=${props.username}&email=${props.email}&token=${props.token}`,
    "Control Tower": `https://controltower.intusystems.info/?email=${props.email}`,
    "Ops Monitor Dashboard": `https://sct.intutrack.com/#!/home?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyIjoib3BzX21vbml0b3IiLCJjbGllbnQiOiJJbnR1Z2luZSBPUFMiLCJjbGllbnRfY2xpZW50IjpudWxsLCJwcml2aWxlZGdlIjoiY2xpZW50Iiwic2NvcGUiOiJDcmVkZW50aWFscyIsImlhdCI6MTU4OTI4MDEyMn0.s7-f-jbfQIyhr0tsH2ztm_2dbDYzMHqvXwaEnfR6FgU&email=${props.email}`,
    "Login Creation": `https://master.d1c5c0wcuywf6j.amplifyapp.com/?token=${props.token}&email=${props.email}`,
    "Delete Pings": `https://master.d2wkgcbf3co97n.amplifyapp.com?user=${props.username || props.email}&email=${props.email}&token=a3gyMnpJMVlrRXlXMlprWDI4VzdhTlhOaU1NRGRDbEZTaTZpNnkzcnE3dmkzRWU1SnFPQUQ4VEpwRjI5UWNVSDoxVEdHZ3phbTdNR2lNamViRWlLY2lYS1dZQm94S3duejNFQUlqbzJsWEc5cEFmWUN2SmxEQ1Ezb0cxOGNuZ0NQ`,
    // "IntuDB": `https://master.dtq956dj9f7s4.amplifyapp.com/iFrame/home`,
    "Compliance Report": "https://genie.intutrack.com/AllClientCompliance/",
    "Client wise Analysis Dashboard": "https://genie.intutrack.com/ClientwiseTrackingMode/",
    "Vendor Dashboard": "https://genie.intutrack.com/VendorDashboard/",
    "User Management V2": `https://master.d1jj835n5wn6fh.amplifyapp.com/?email=${props.email}&token=${props.keycloakAccessToken}`,
    "Add Flipkart Device": "",
    "SSO Creation": "",
    // 'UpTime Monitor': 'https://stats.uptimerobot.com/GgngYhJE0B',
    APIS: "",
    // PARCEL: "",
    parcel: `https://tp-ops.intusystems.info/parcel/actions?username=${props.username}&email=${props.email}&tp-ops-token=${TP_OPS_TOKEN}`,
    trace: `https://tp-ops.intusystems.info/trace/actions?username=${props.username}&email=${props.email}&tp-ops-token=${TP_OPS_TOKEN}`,
  };

  const hasUserMgmtAccess = (props.profile?.groups || []).includes(
    "operations_user_mgmt"
  );
  if (!hasUserMgmtAccess) {
    delete apps["User Management V2"];
  }
  const specialApps = {
    // 'Tickets V2': 'https://development.d2jq2wvhkq6025.amplifyapp.com/?token=' + props.token
  };
  const excel = {
    "Client Credentials":
      " https://docs.google.com/spreadsheets/d/1ejVsgN95Tbozwdmy27arjSnSt4BFCn_MrolF3wyFmKM/edit#gid=630323623",
    "Training Sheet":
      "https://docs.google.com/spreadsheets/d/1q9DX7zsFHnkahxsUoxFswpeIgXaSoX5pI4p27UsGevo/edit?ts=5d959f2b#gid=0",
    "Knowledge Centre":
      "https://docs.google.com/spreadsheets/d/1jJKhB5M4ALrKW6BMH1AYKCZXIWexrL1D8tQtvh_uSAE/edit?ts=5d2c383e#gid=1168403697",
    "Operation Support Shifts":
      "https://docs.google.com/spreadsheets/d/1XHSJuglc27JEpWNNQzx0gP9u_UQ39rZpEwI5Q73N67M/edit?ts=5f9010db#gid=447708271",
    "Implementation Resource":
      "https://docs.google.com/spreadsheets/d/1ZpFrf4_FtSrqz5_MHEQU6zISpApaX4Ayk2IlRM2nyLc/edit#gid=34161179",
  };

  // const showApps = {
  //   // "aryanmaurya@intugine.com": ["parcel"],
  //   "rakshit@intugine.com": [ "trace", "parcel"],
  //   "harsh@intugine.com": ["Device", "APIS"],
  //   "prakashmishra@intugine.com": ["Device", "APIS"],
  //   "aakash@intugine.com": ["Device"],
  //   "accounts@intugine.com": ["Device"],
  //   // "kshitij@intugine.com": ["Device"],
  //   "dhairya@intugine.com": ["Control Tower", "Ops View", "Tickets"],
  //   "rsaundatikar@intugine.com": ["Tickets V2"],
  //   // "anubha@intugine.com": ["Tickets V2", "Tickets"],
  //   "chinmayparadkar@intugine.com": ["Device", "APIS"],
  //   // "rahulbisen@intugine.com": ["Tickets V2", "Ops View"],
  //   // "pandurang@intugine.com": ["Tickets V2", "Ops View"],
  //   // "ashutosh@intugine.com": ["Tickets V2", "Ops View"],
  //   "febin@intugine.com": ["Tickets V2", "Ops View"],
  //   "admin@intugine.com": ["APIS"],
  //   // "navneet@intugine.com": ["Tickets V2"],
  //   // "siddhantchourasia@intugine.com": ["Tickets V2"],
  //   "customersuccess@intugine.com": [
  //     "Tickets V2",
  //     "Ops Monitor Dashboard",
  //     "Inspect",
  //     "APIS",
  //     "Device",
  //   ],
  //   "umar@intugine.com": ["Client wise Analysis Dashboard", "Compliance Report"],
  //   "prakharverma@intugine.com": ["Client wise Analysis Dashboard", "Compliance Report"],
  //   "dharti@intugine.com": ["Client wise Analysis Dashboard", "Compliance Report"],
  //   //AM TEAM  - 6 Members
  //   "rutvij@intugine.com": ["User Mgmgt", "Ops View", "Tickets V2"],
  //   // "ashutosh@intugine.com": ["User Mgmgt", "Ops View", "Tickets V2"],
  //   "sangamtirtharaj@intugine.com": ["User Mgmgt", "Ops View", "Tickets V2"],
  //   "aditya.agrawal@intugine.com": ["User Mgmgt", "Ops View", "Tickets V2","Client wise Analysis Dashboard", "Compliance Report"],
  //   "pandurang@intugine.com": ["User Mgmgt", "Ops View", "Tickets V2"],
  //   "mouryakota@intugine.com": ["User Mgmgt", "Ops View", "Tickets V2"],
  // };

  const specialAccess = {
    // 'niranjan@intugine.com': ['Tickets V2'],
    // 'rohit@intugine.com': ['Tickets V2'],
    // 'anubha@intugine.com': ['Tickets V2'],
    // 'mayankmittal@intugine.com': ['Tickets V2']
  };

  const defaulAccess = ["Ops View"];

  const hasFullAccess =(props.profile?.groups || []).includes("operations-admin");
  const specificAccess = props.profile?.operation_access?.length ? props.profile.operation_access : []

  React.useEffect(() => {
    reactGA.initialize("UA-168562633-1"); //niranjan bhaiya
    // reactGA.initialize('UA-168542280-1'); //rohit
  }, []);

  React.useEffect(() => {
    if (!props.loggedIn) {
      history.push("/login");
      return;
    }

    const profileSpecificAccess = props.profile?.operation_access?.length
      ? props.profile.operation_access
      : [];
    const isFullAccess =
      (props.profile?.groups || []).includes("operations-admin") ||
      (props.profile?.groups || []).includes("/operations-admin");
    const defaultHomePath =
      "/home/" +
      (isFullAccess
        ? "Tickets V2"
        : (profileSpecificAccess.length
            ? profileSpecificAccess
            : defaulAccess)[0]);

    // Logged-in visit to "/" must go to the default app (token may already be fresh).
    if (
      window.location.pathname === "/" ||
      window.location.pathname === ""
    ) {
      history.push(defaultHomePath);
    }

    if (!props.email || !props.keycloakAccessToken) {
      return;
    }

    if (
      props.keycloakRefreshToken &&
      props.keycloakAccessTokenExpiresAt &&
      !isAccessTokenValid(props.keycloakAccessTokenExpiresAt)
    ) {
      return;
    }

    const profileKey = getProfileKey({
      email: props.email,
      username: props.username,
      profile: props.profile,
    });

    const profileChanged =
      fetchedForProfileKeyRef.current !== null &&
      fetchedForProfileKeyRef.current !== profileKey;
    const needsToken =
      !props.token || !isIntugineTokenFresh(props.intugineTokenFetchedAt);

    if (!needsToken && !profileChanged) {
      if (fetchedForProfileKeyRef.current === null) {
        fetchedForProfileKeyRef.current = profileKey;
      }
      return;
    }

    fetchedForProfileKeyRef.current = profileKey;

    axios
      .get(
        "https://umm0xqw159.execute-api.ap-south-1.amazonaws.com/v1/generate_intugine_user_token_with_keycloak_auth",
        {
          headers: {
            Authorization: `Bearer ${props.keycloakAccessToken}`,
          },
        }
      )
      .then(function (res) {
        props.logIn({
          token: res.data.token,
          username: props.username,
          email: props.email,
          profile: props.profile,
        });

        if (
          window.location.pathname === "/" ||
          window.location.pathname === "" ||
          window.location.pathname === "/home" ||
          window.location.pathname === "/home/"
        ) {
          history.push(defaultHomePath);
        }
      })
      .catch(function (error) {
        // Don't auto-logout on transient Intugine token API failures.
        // Only force login when Keycloak auth is clearly rejected.
        const status = error?.response?.status;
        if (status === 401 || status === 403) {
          history.push("/login");
        } else {
          console.error("Failed to refresh Intugine user token:", error);
        }
      });
  }, [
    props.loggedIn,
    props.email,
    props.username,
    props.token,
    props.intugineTokenFetchedAt,
    props.profile,
    props.keycloakAccessToken,
    props.keycloakRefreshToken,
    props.keycloakAccessTokenExpiresAt,
    history,
    props.logIn,
  ]);

  return (
    <div className="App">
      <Switch>
        <Route
          exact
          path="/login"
          render={(props) => (
            <Login
              {...props}
              defaulAccess={defaulAccess}
              // showApps={showApps}
              // fullAcess={fullAcess}
              // hasFullAccess={hasFullAccess}
            />
          )}
        ></Route>
        <Route
          path="/home"
          render={(props) => (
            <Home
              {...props}
              // specialApps={specialApps}
              defaulAccess={defaulAccess}
              // specialAccess={specialAccess}
              // showApps={showApps}
              excel={excel}
              apps={apps}
              // fullAcess={fullAcess}
              specificAccess={specificAccess}
              hasFullAccess={hasFullAccess}
            />
          )}
        ></Route>
      </Switch>
    </div>
  );
}

const mapStateToProps = (state) => ({
  loggedIn: state.loggedIn,
  email: state.email,
  username: state.username,
  token: state.token,
  intugineTokenFetchedAt: state.intugineTokenFetchedAt,
  profile: state.profile,
  keycloakAccessToken: state.keycloakAccessToken,
  keycloakRefreshToken: state.keycloakRefreshToken,
  keycloakAccessTokenExpiresAt: state.keycloakAccessTokenExpiresAt,
});

const mapDispatchToProps = (dispatch) => ({
  logIn: (payload) => dispatch({ type: actions.LOGIN, payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
